import axios from "axios";
import * as d3 from "d3";
import {
    colonAnnotation,
    fw_progressive_1way,
    make_x_gridlines,
    make_y_gridlines,
    numberFormat,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, filterParam, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.post(url, filterParam).then(response => {
        let data = response.data

        console.log("res", data)

        data.forEach(function (d) {
            d.dim3_name = new Date(d.dim3_name);
            d.metric1 = +d.metric1;
            console.log("date", d.dim3_name)

        });

        //Set the x and y values
        var x1Scale = d3.scaleTime().range([0, chart.width]);
        var y1Scale = d3.scaleLinear().range([chart.height, 0]);

        var formatTime = chart.vizSpecific4 == 'year-month' ? d3.timeFormat("%Y-%b") : d3.timeFormat("%Y");

        // Define the axes
        var x1AxisLabel = d3.axisBottom(x1Scale).tickFormat(formatTime);

        var y1AxisLabel = d3.axisLeft(y1Scale).ticks(10).tickFormat(numberFormat);

        x1Scale.domain(d3.extent(data, function (d) {
            return d.dim3_name;
        }));

        //  console.log("road",d3.extent(data, function(d) { return d.dim3_name; }))

        y1Scale.domain([0, d3.max(data, d => d.metric1)]);

        //     Define the line
        var dataline = d3.line()
            .x(function (d) {
                return x1Scale(d.dim3_name);
            })
            .y(function (d) {
                return y1Scale(d.metric1);
            });

        var svg = d3.select(divId).select("svg").remove();
        // Adds the canvas
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .attr("font", "Arial")
            .style("font-size", "14px")
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

        var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way);

        // set the colour scale
        // var metric2ColorScale = d3.scaleOrdinal().domain(['N-Average','State']);
        var metric2ColorScale = d3.scaleOrdinal().domain([...new Set(data.map(obj => obj.dim2_name))]);
        console.log("Distinct dim2_names ", [...new Set(data.map(obj => obj.dim2_name))])
        // metric1ColorScale.domain(dNest);

        // Scale the range of the data
        // var tickVariant=Math.floor(d3.max(data,(d)=>d.metric1)/(chart.width/100)/10)*10
        //   var x1Scalemin=Math.floor(d3.min(data, (d) =>{ return d.metric1 / 200}))*200
        //   x1Scale.domain([d3.min(data, (d) =>{ return d.dim3_name }), d3.max(data, (d) =>{ return d.dim3_name })]);

        var dNest = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            })
            .key(function (d) {
                return d.dim2_name;
            }).entries(data)

        // spacing for the legend
        var legendSpace = chart.width / dNest.length;

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        console.warn(legendSpace)
        // Add the X Axis
        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + chart.height + ")")
            .call(x1AxisLabel)
            .selectAll('text')
            .style('text-anchor', 'end')
            .style("font-size", axisLabelFontSize)
            .attr('dx', '-.8em')
            .attr('dy', '-.20em')
            .attr('transform', 'rotate(-60)')

        svg.append('text')
            .attr('x', (chart.width / 2))
            .attr('y', chart.height + chart.margin.bottom - chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style("font-size", fontSize)

        // Add the Y Axis
        svg.append("g")
            .attr("class", "y axis")
            .call(y1AxisLabel)
            .style("font-size", axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left + 5)
            .attr('x', 0 - (chart.height / 2) + 50)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.y1AxisDisplayName)

        // Loop through each symbol / key
        var lines = svg.selectAll(".lines")
            .data(dNest)
            .enter()
            .append("g")
            .attr("stroke", function (d) {
                return metric1ColorScale(d.key)
            });

        var paths = lines.selectAll(".line")
            .data(function (d) {
                return d.values
            })
            .enter()
            .append("path");

        paths.attr("fill", "none")
            .attr("d", function (d) {
                return dataline(d.values)
            })
            .style("stroke-width", 3)
            .attr("class", function (d) {
                if (d.key == chart.y2MetricTooltip) {
                    return 'plotdashed';
                } else {
                    return 'plotline';
                }
            })
            .on("mousemove", function () {
                var mx = d3.mouse(svg.node())[0],
                    c = 1e10,
                    idx = -1;
                xs.forEach(function (x, i) {
                    var dis = Math.abs(x - mx);
                    if (dis < c) {
                        c = dis;
                        idx = i;
                    }
                    div.style("display", "block");
                });

                var dot = dots.nodes()[idx],
                    d3Dot = d3.select(dot);
                d3Dot.on("mousemove").call(dot, d3Dot.datum()).attr("r", 5);
            })
            .on("mouseout", function () {
                div.style("display", "none").attr("r", 5)
            })

        var xs = [];

        var dots = svg.selectAll("dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("r", 5)
            .attr("cx", function (d) {
                var xp = x1Scale(d.dim3_name)
                xs.push(xp);
                return xp;
            })
            .attr("cy", function (d) {
                return y1Scale(d.metric1);
            })
            .style("fill", function (d) {
                return metric1ColorScale(d.dim1_name)
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(100)
                    .style("opacity", .9)
                    .style("display", "block")

                var self = d3.select(this);
                self.attr("r", 5);

                div.html(chart.x1MetricTooltip + colonAnnotation + d.dim1_name + "(" + d.dim2_name + ")" + "<br/>" + chart.x2MetricTooltip
                    + colonAnnotation + formatTime(d.dim3_name) + "<br/>" + chart.y1MetricTooltip + colonAnnotation + numberFormat(d.metric1)
                )
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px")

            })
            .on("mouseout", function () {
                div.transition()
                    .style("opacity", 0)
                    .style("display", "none")

                var self = d3.select(this)
                self.attr("r", 5);

            });
        //.on("mouseover", y1tip.show)
        //.on("mouseout", y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        // Add the Legend
        var y1legend = svg.selectAll('.legend')
            .data(metric2ColorScale.domain())
            .enter().append('g')
            .attr('class', 'legend')
            //.attr("transform", function (d, i) { return "translate(30," + i * 25 + ")"; });
            .attr('transform', function (d, i) {
                var horz = 180 * i; // NEW
                var vert = 100;       // NEW
                return 'translate(' + horz + ',' + vert + ')';        // NEW
            });
        y1legend.append('line')
            .attr("x1", 0)
            .attr("x2", 40)
            .attr("y1", chart.height)
            .attr("y2", chart.height)
            .attr("stroke-width", 3)
            .attr("stroke", "black")
            // .attr("stroke-opacity", "3")
            .attr("class", function (d) {
                if (d.startsWith(chart.y2MetricTooltip)) {
                    return 'plotdashed';
                } else {
                    return 'plotline';
                }
            })

        y1legend.append('text')
            .attr('x', 50)
            .attr('y', chart.height + 10 * chart.vizSpecific1 + 10)
            //.attr('dy', '.1em')
            //.style('fill', metric1ColorScale)
            .text(function (d) {
                if (d.length > 10)
                    return d.substring(0, 7)
                else {
                    return d
                }
            })
            .style('font-size', '25px')


        var y2legend = svg.append('g')
            .selectAll('g')
            .data(metric1ColorScale.domain())
            .enter()
            .append('g')
            //.attr('transform', (d, i) => 'translate(0,' + i * 20 + ')')
            .attr('transform', function (d, i) {                     // NEW
                //  var height = 0;          // NEW
                var horz = 250 * i; // NEW
                var vert = 25;       // NEW
                return 'translate(' + horz + ',' + vert + ')';        // NEW
            });

        y2legend.append('rect')
            .attr('x', 10)
            .attr('y', chart.height + 120)
            .attr('width', 20)
            .attr('height', 20)
            .attr('fill', d => {
                return metric1ColorScale(d)
            })

        y2legend.append('text')
            .attr('x', 40)
            .attr('y', chart.height + 120)
            .attr('dy', '0.75em')
            .text((d) => {
                return d
            })
            .style('font-size', "25px")

        if (gridflag == true) {
            // add the X gridlines
            svg.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(make_x_gridlines(x1Scale)
                    .tickSize(-chart.height)
                    .tickFormat(""))

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chart.width)
                    .tickFormat(""))
        }
    });
}
